/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import Lottie from '@/components/Lottie/ReactLottie';
import PopUp from '@/components/Modal/PopUp';
import Rectangle from '@/assets/images/categories/rectangle.png';
import animationData from './animationData.json';
import './style';

class Download extends React.PureComponent {
  static propTypes = {
    callback: PropTypes.func,
    progress: PropTypes.number,
    isReturnTo: PropTypes.bool,
    goBackTo: PropTypes.func,
  };

  state = {
    isStopped: true,
  }

  componentDidMount() {
    setTimeout(() => this.setState({ isStopped: false }), 0);
    // 点击暂停
    // this.animation.handleClickToPause = null;
    // 数字越大数度越慢
    const speed = 100;
    const oUl = document.getElementsByTagName('ul')[0];
    const oLi = document.getElementsByTagName('li');
    // 复制一遍ul
    oUl.innerHTML += oUl.innerHTML;
    // ul的宽度是所有li宽度之和，复制ul之后的整个ul的宽度就是li的长度乘以一个li的宽度
    oUl.style.width = `${oLi.length * oLi[0].offsetWidth}px`;
    this.timer = setInterval(this.fnMove, speed);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  fnMove = () => {
    const oUl = document.getElementsByTagName('ul')[0];
    const iSpeed = 1;
    if (oUl.offsetLeft >= 0) {
      // 将整个复制的ul向左拖拽直至整个ul中的第一张图归位到起点
      oUl.style.left = `-${oUl.offsetWidth / 2}px`;
    }
    // 给ul一个速度让整个ul的offsetLeft增加或减少，速度为正则向右移动，速度为负则向左移动
    oUl.style.left = `${oUl.offsetLeft + iSpeed}px`;
  }

  handleDownLoad = () => {
    this.props.callback();
  }

  goBack = () => {
    this.props.goBackTo();
  }

  hasError = () => this.props.progress === -1;


  render() {
    const defaultOptions = {
      loop: true,
      autoplay: false,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const lottieStyles = {
      width: '80px',
      height: '30px',
      overflow: 'hidden',
      margin: '0px auto',
      outline: 'none',
      position: 'absolute',
      zIndex: '10000000000',
      left: '50%',
      top: '45%',
      transform: 'translate(-50%, -50%)',
    };
    const eventListeners = [
      {
        eventName: 'complete',
        // callback: () => this.props.callback(),
      },
    ];
    return (
      <PopUp>
        <div>
          {!this.hasError()
            ? (
              <Lottie
                ref={(e) => { this.animation = e; }}
                style={lottieStyles}
                options={defaultOptions}
                isStopped={this.state.isStopped}
                eventListeners={eventListeners}
                speed={1}
              />
            )
            : <div className="download-error-txt">加载失败</div>
          }
          <div className="download-progress">
            <ul>
              {Array.from({ length: 14 }).map((_, index) => <li key={index}><img src={Rectangle} alt="" /></li>)}
            </ul>
            <div className={`download-slider${this.hasError() ? ' error' : ''}`} style={{ width: `${this.props.progress}%` }} />
          </div>
          <div className="download-tips">
            <div>正在下载音效，文件较大</div>
            <div>请稍后，建议使用流畅网络下载！</div>
          </div>
          <div className="download-border" />
          {
            this.props.isReturnTo ? (<div className="download-error-btn" onClick={this.goBack}>返回</div>) : ''
          }
          {this.hasError() && <div className="download-error-btn" onClick={this.handleDownLoad}>重新加载</div>}
        </div>
      </PopUp>
    );
  }
}

export default Download;
